var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { id: "modifierModal", centered: "", title: _vm.actionDisplay },
      on: { shown: _vm.open, hidden: _vm.clear },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "b-form",
        { staticClass: "create-tax-form" },
        [
          _c(
            "info-row",
            { staticClass: "info-main-row", attrs: { title: "Name" } },
            [
              _c(
                "b-col",
                { staticClass: "input-group" },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      title: "tax Name",
                      placeholder: "Liquor Tax",
                      required: "",
                      state: _vm.fieldState.taxName,
                    },
                    model: {
                      value: _vm.taxName,
                      callback: function ($$v) {
                        _vm.taxName = $$v
                      },
                      expression: "taxName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "info-row",
            { staticClass: "info-main-row", attrs: { title: "Description" } },
            [
              _c(
                "b-col",
                { staticClass: "input-group" },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      title: "Description",
                      placeholder: "Appled to all alcoholic beverages",
                      required: "",
                      state: _vm.fieldState.description,
                    },
                    model: {
                      value: _vm.description,
                      callback: function ($$v) {
                        _vm.description = $$v
                      },
                      expression: "description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "info-row",
            { staticClass: "info-main-row", attrs: { title: "Calculation" } },
            [
              _c(
                "b-col",
                { staticClass: "input-group type-select" },
                [
                  _c("b-form-select", {
                    attrs: {
                      title: "Calculation",
                      required: "",
                      state: _vm.fieldState.calculation,
                      options: _vm.calculations,
                    },
                    model: {
                      value: _vm.calculation,
                      callback: function ($$v) {
                        _vm.calculation = $$v
                      },
                      expression: "calculation",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "info-row",
            { staticClass: "info-main-row", attrs: { title: "Type" } },
            [
              _c(
                "b-col",
                { staticClass: "input-group type-select" },
                [
                  _c("b-form-select", {
                    attrs: {
                      title: "Type",
                      required: "",
                      state: _vm.fieldState.calculation,
                      options: _vm.modifierTypes,
                    },
                    model: {
                      value: _vm.modifierType,
                      callback: function ($$v) {
                        _vm.modifierType = $$v
                      },
                      expression: "modifierType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "info-row",
            { staticClass: "info-main-row", attrs: { title: "Rate" } },
            [
              _vm.show
                ? _c("currency-input", {
                    ref: "rateInput",
                    attrs: {
                      name: "Default Rate",
                      currencySymbol:
                        _vm.calculation === _vm.modifierRateTypes.FIXED
                          ? "$"
                          : "%",
                      amount: _vm.defaultRate,
                      fieldState: _vm.fieldState.defaultRate,
                    },
                    on: {
                      "update:amount": function ($event) {
                        _vm.defaultRate = $event
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("Taggregator", {
            ref: "tagsTaggregator",
            staticClass: "mt-4",
            attrs: {
              name: "tags",
              label: "Applied To:",
              labelKey: "name",
              items: _vm.getTags,
              selections: _vm.selectedTags,
              minimum: 0,
              quickAddCallback: _vm.quickAddTag,
              quickAddMinWordCount: 1,
              quickAddMinWordLength: 1,
              quickAddDescription: "Please provide valid item name",
              onAdd: _vm.addModifierTag,
              onRemove: _vm.removeModifierTag,
              quickAddHasUniqueName: true,
            },
            on: {
              "update:selections": function ($event) {
                _vm.selectedTags = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "result",
                fn: function ({ result }) {
                  return [
                    _c("span", { staticClass: "result-label" }, [
                      _vm._v(
                        "\n          " + _vm._s(result.name) + "\n        "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "selection",
                fn: function ({ selection }) {
                  return [
                    _vm._v("\n        " + _vm._s(selection.name) + "\n      "),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer",
        },
        [
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(_vm._s(_vm.warningText)),
          ]),
          _vm._v(" "),
          _vm.tax.id
            ? _c(
                "b-btn",
                {
                  staticClass: "float-left",
                  attrs: { variant: "danger" },
                  on: { click: _vm.deleteTax },
                },
                [_vm._v("\n      Delete Tax\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "float-right",
              attrs: { variant: "success" },
              on: { click: _vm.triggerTax },
            },
            [_vm._v("\n      " + _vm._s(_vm.actionDisplay) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRequesting
        ? _c(
            "div",
            { staticClass: "spinner-loading" },
            [_c("spinner-loader")],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }